export const BackdropBottomAnchor = () => {
    return (
        <div className="bottom-0 left-0"> {/* Anchored to bottom of the page */}
            <img
                src="/images/Coral Cliff.png"
                className='absolute z-10 h-auto w-[35vw] bottom-[10vw] left-0'
                alt="Coral Cliff"
            />

            <img
                src="/images/Blue Coral.png"
                className='absolute z-40 h-auto w-[20vw] bottom-[25vw] left-[5vw] opacity-50'
                alt="Blue Coral"
            />

            <img
                src="/images/Purple Coral.png"
                className='absolute z-40 h-auto w-[15vw] bottom-[25vw] left-[7vw] opacity-50'
                alt="Purple Coral"
            />

            <img
                src="/images/Crab Cliff.png"
                className='absolute bottom-[0vw] left-[0vw] z-10 w-[70vw]'
                alt="Crab Cliff"
            />

            <img
                src="/images/Crab.png"
                className='hover:animate-shake absolute z-50 h-auto w-[20vw] bottom-[5vw] left-[30vw] opacity-30'
                alt="Crab Cliff"
            />

            <img
                src="/images/AboutLeftSpeaker.png"
                alt="About Left Speaker"
                className="absolute w-[17vw] bottom-[12vw] left-[2vw] z-50 brightness-50"
            />

            <img
                src="/images/Background Left Cliff.png"
                alt="Background Left Cliff"
                className='absolute bottom-0 left-0 z-0 w-[60vw]'
            />

            <img
                src="/images/Background Right Cliff.png"
                className='absolute z-0 h-auto w-[50vw] bottom-[0vw] right-[-2vw]'
                alt="Background Left Cliff"
            />

            <img
                src="/images/CliffCoveringSpaceship.png"
                className='absolute z-40 h-auto w-[70vw] bottom-0 right-0'
                alt="Cliff Covering Spaceship"
            />

            <img
                src="/images/SpaceshipLighting.png"
                className='absolute z-20 h-auto w-[80vw] bottom-0 right-0'
                alt="Space Lighting"
            />

            <img
                src="/images/AnglerFish.png"
                className='absolute z-50 h-auto w-[43vw] bottom-[15vw] right-[5vw]'
                alt="Angler Fish"
            />

            <img
                src="/images/Spaceship.png"
                className='absolute z-30 h-auto w-[33vw] bottom-[0vw] right-[5vw]'
                alt="Spaceship"
            />

            <img
                src="/images/Footer Mid Lighting.png"
                alt="Footer Mid Lighting"
                className="absolute w-[50vw] z-0 right-[12vw] bottom-[12vw]"
            />

            <img
                src="/images/Footer Down Lighting.png"
                alt="Footer Down Lighting"
                className="animate-pulse absolute w-[100vw] z-0 right-[0vw] bottom-[0vw]"
            />
        </div>
    )
}